import React, { useEffect, useState } from 'react';
import { SubmitButton } from 'components/Button/Button.styles';
import Column from "components/Grid/Column";
import Row from "components/Grid/Row";
import TextField from './FormComponents/TextField';
import Form from './FormComponents/Form';
import LoadingOverlay from 'components/Layout/MapView/LoadingOverlay/LoadingOverlay';
import FuzzySearchSelect from 'components/FuzzySearch/FuzzySearchSelect';
import { useDavidApi } from 'utility/DavidApi/DavidApi';

const AddForemanForm = ({
    foreman = {},
    hideModal,
    ...otherProps
}) => {
    const api = useDavidApi();
    const [inputs, setInputs] = useState(foreman);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState(null);
    const [clientFuzzySearchSelectItems, setClientFuzzySearchSelectItems] = useState({});

     useEffect(() => {
        if (api.clients !== null) {
            setClients(api.clients);
            return;
        }

        (async () => {
            const response = await api.getClients();
            setClients(response);
        })();
    }, [api.clients]);

    useEffect(() => {
        if (!clients?.length) {
            return;
        }

        setClientFuzzySearchSelectItems(clients.map(client => ({
            label: client.name,
            value: {id: client.id},
            id: client.id,
        })));
    }, [clients]);

    let submitHandler = () => {
        (async () => {
            setLoading(true);
            const foremanInfo = {
                ...inputs,
                client: `/api/clients/${inputs.client.id}`,
            };

            await api.postForemen(foremanInfo);

            await api.fetchClients();

            setTimeout(() => {
                hideModal();
                setLoading(false);
            }, 1500);
        })();
    };

    if (foreman?.id) {
        submitHandler = () => {
            (async () => {
                await api.patchForemen(inputs);
                setTimeout(() => {
                    hideModal()
                },
                    1500
                );
            })();
        }
    }

    return (
        <Form
            successMessage='Foreman Added!'
            values={inputs}
            setValues={setInputs}
            asyncSubmitHandler={submitHandler}
            errors={errors}
            setErrors={setErrors}
            {...otherProps}
        >
        {loading && (
            <LoadingOverlay>
                <h2>
                    Foreman added! Refreshing...
                </h2>
            </LoadingOverlay>
        )}
            <TextField
                label="Foreman Name"
                name="name"
                required
            />
            <FuzzySearchSelect
                label="Client"
                name="client"
                placeholder="Select One..."
                items={clientFuzzySearchSelectItems}
                // addChoiceButtonLabel="Add Client"
                // addChoiceForm={AddClientForm}
                required
            />
            <Row gutter={15}>
                <Column width={1/2}>
                    <TextField
                        label="Phone"
                        name="phone"
                        required
                    />
                </Column>
                <Column width={1/2}>
                    <TextField
                        label="Email"
                        name="email"
                        required
                    />
                </Column>
            </Row>

            <SubmitButton>Submit</SubmitButton>
        </Form>
    )
  }

export default AddForemanForm;
